<template>
<div class="ThreeImagesBox">
    <div v-if="isNotTwoOnly" class="imagesBoxTop">
        <img class="containerImage_image" :src="imageOneSrc" alt="">
        <p class="containerImage_description">{{ imageOneDes }}</p>
    </div>
    <div class="imagesBoxBottom">
      <div class="images">
        <div class="left">
          <img :src="imageTwoSrc" alt="">
        </div>
        <div class="right">
          <img :src="imageThreeSrc" alt="">
        </div>
      </div>
      <p class="containerImage_description">{{ imageTwoDes }}</p>
  </div>
</div>

</template>
<script>
import srcRWD from '@/mixin/srcRWD.js'

export default {
  name: 'YouTubeVideo',
  data () {
    return {
      
    }
  },
  mounted () {

  },
  props: {
    imageOneSrc: String,
    imageTwoSrc: String,
    imageThreeSrc: String,
    imageOneDes: {
      type: String,
      default: ''
    },
    imageTwoDes: {
      type: String,
      default: ''
    },
    isNotTwoOnly: {
      type: Boolean,
      default: true
    }
  },
  mixins: [srcRWD],
  components: {

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.imagesBoxTop {
  width: 92%;
  margin: 60px auto 30px;
  @media (min-width: 768px) and (max-width: 1279.98px) {
      width: 84%;
      margin: 80px auto 30px;
  }
  @media (min-width: 1280px) {
      width: 78%;
      margin: 80px auto 30px;
  }
  .containerImage_image {
      width: 100%;
  }

  .containerImage_description {
      margin: 0;
      padding-top: 5px;
      line-height: 1.4;
      font-size: 0.9rem;
      color: #7b7a7a;
      @media (min-width: 768px) and (max-width: 1279.98px) {
          font-size: 1rem;
      }
  }
}
.imagesBoxBottom {
      width: 92%;
      margin: 0px auto 60px;
      @media (min-width: 768px) and (max-width: 1279.98px) {
        width: 84%;
      margin: 0px auto 80px;
      }
      @media (min-width: 1280px) {
        width: 78%;
      margin: 0px auto 80px;
      }
      .images {
        display: flex;
        flex-direction: column;
        @media (min-width: 768px) and (max-width: 1279.98px) {
          flex-direction: row;
        }
        @media (min-width: 1280px) {
          flex-direction: row;
        }
        .left {
          
          padding-bottom: 30px;
           @media (min-width: 768px) and (max-width: 1279.98px) {
            padding-right: 10px;
            padding-bottom: 0px;
          }
          @media (min-width: 1280px) {
            width: 50%;
            padding-right: 10px;
            padding-bottom: 0px;
          }
        }
        .right {
          @media (min-width: 768px) and (max-width: 1279.98px) {
            padding-left: 10px;
          }
          @media (min-width: 1280px) {
            width: 50%;
            padding-left: 10px;
          }
        }
        img {
          width: 100%;
        }
      }
      .containerImage_description {
          margin: 0;
          padding-top: 5px;
          line-height: 1.4;
          font-size: 0.9rem;
          color: #7b7a7a;
          @media (min-width: 768px) and (max-width: 1279.98px) {
              font-size: 1rem;
          }
      }
    }
</style>
